import { template as template_b73137db7cb04e50a04d05e0541d9a3d } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import RequestClinicianPagination from './pagination';
import RequestClinicianSearchCard from './card';
import RequestClinicianSearchFilteredResultsSummary from './filtered-results-summary';
import RequestClinicianSearchFiltersSummaryBar from './filters-summary-bar';
import RequestClinicianSearchMobileFiltersOverlay from './mobile-filters-overlay';
import RequestStepsLoadingLoadingClinicianSearch from 'client-portal/components/request/steps/loading/loading-clinician-search';
import styles from './page.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import t from 'ember-intl/helpers/t';
const SKELETON_SLOTS = [
    0,
    1
];
export default class RequestClinicianSearchPage extends Component {
    @service
    router;
    @service
    clinicianSearch;
    @service
    session;
    styles = styles;
    skeletonSlots = SKELETON_SLOTS;
    get rootClassNames() {
        return `${styles.component}${this.session.currentClient ? ' signed-in' : ''}`;
    }
    get hasNoClinicians() {
        return !this.args.clinicians?.length;
    }
    get hasCatalogError() {
        return !!this.clinicianSearch.sendAll.loadError;
    }
    get showEmptyResults() {
        return this.clinicianSearch.sendAll.isLoaded && this.hasNoClinicians;
    }
    get isInitialLoading() {
        let { sendAll } = this.clinicianSearch;
        if (sendAll.loadError) {
            return false;
        }
        return sendAll.isLoading || !sendAll.isLoaded;
    }
    get showResultsMessage() {
        return this.hasCatalogError || this.showEmptyResults;
    }
    get showSortingIndicator() {
        let filteredTotal = this.args.meta?.page?.total ?? 0;
        return (filteredTotal >= 25 && !this.isInitialLoading && !this.showResultsMessage && this.clinicianSearch.nextSlots.isEnriching);
    }
    goToPage = (pageNumber, event)=>{
        event?.preventDefault?.();
        this.router.transitionTo({
            queryParams: {
                pageNumber
            }
        });
    };
    static{
        template_b73137db7cb04e50a04d05e0541d9a3d(`
    <div class={{this.rootClassNames}} data-test-clinician-search-page>
      <RequestClinicianSearchFiltersSummaryBar
        @meta={{@meta}}
        @isLoading={{this.isInitialLoading}}
      />
      <div class="filtered-count-wide-only" data-test-clinician-search-filtered-count>
        <RequestClinicianSearchFilteredResultsSummary
          @meta={{@meta}}
          @isLoading={{this.isInitialLoading}}
        />
      </div>

      {{#if this.showSortingIndicator}}
        <div
          class="sorting-indicator"
          role="status"
          aria-live="polite"
          data-test-clinician-search-sorting-overlay
        >
          {{svgJar "circle-notch" class="icon-spinner" aria-hidden="true"}}
          {{t "booking.clinicianSearch.sortingByNextAvailability"}}
        </div>
      {{/if}}

      <div
        class="{{unless this.isInitialLoading 'cards'}} {{if this.showResultsMessage 'is-empty'}}"
        data-test-clinician-search-results
      >
        {{#if this.isInitialLoading}}
          <RequestStepsLoadingLoadingClinicianSearch
            @count={{this.skeletonSlots}}
            @hideBarItems={{true}}
          />
        {{else if this.hasCatalogError}}
          <div class="empty-results" role="alert" data-test-clinician-search-error>
            {{t "booking.clinicianSearch.catalogError"}}
          </div>
        {{else if this.showEmptyResults}}
          <div class="empty-results" role="status" data-test-clinician-search-empty>
            {{t "booking.clinicianSearch.emptyResults"}}
          </div>
        {{else}}
          {{#each @clinicians key="id" as |clinician|}}
            <RequestClinicianSearchCard
              @model={{clinician}}
              @meta={{@meta}}
              @nextStep={{@nextStep}}
            />
          {{/each}}
        {{/if}}
      </div>

      {{#unless this.isInitialLoading}}
        <RequestClinicianPagination @meta={{@meta}} @onPageChange={{this.goToPage}} />
      {{/unless}}

      <RequestClinicianSearchMobileFiltersOverlay @meta={{@meta}} />
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
